import * as Sentry from '@sentry/react';

export function setupSentry() {
  const SENTRY_DSN = import.meta.env.REACT_APP_SENTRY_DSN;

  if (!SENTRY_DSN) {
    throw new Error('Missing SENTRY_DSN value on the environment variables');
  }

  if (!import.meta.env.REACT_APP_ALLURION_ENV) {
    // eslint-disable-next-line no-console
    console.warn('Missing SENTRY environment value');
  }

  if (!import.meta.env.REACT_APP_BUILD_NUMBER) {
    // eslint-disable-next-line no-console
    console.warn('Missing SENTRY release value');
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.REACT_APP_ALLURION_ENV,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    release: import.meta.env.REACT_APP_BUILD_NUMBER,
    denyUrls: ['localhost'],
    tracesSampleRate: 0.1, // Capture 10% of transactions for performance monitoring
    // Our Sentry plan includes 50 replays/month. Record nothing for a session that
    // goes fine, and a tenth of the ones that hit an error. Keep these two rates
    // the same across every app.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.1,
  });
}
